import React from 'react'
import PropTypes from 'prop-types'
import './_styles.scss'
import Asset from '../../../../../requests/apa/Asset'
import Utils from '../../../../../utils/Utils'

const CardTop4to10 = ({ player }) => {
  return (
    <div className='estadisticas-top4to10'>
      <div className='estadisticas-top4to10__rank-block'>
        <span className='estadisticas-top4to10__rank'>{player.position}</span>
      </div>

      <div className='estadisticas-top4to10__image-block'>
        <img
          className='estadisticas-top4to10__image'
          src={player.player.image ? player.player.image : Asset.get('eventodeportivo_placeholder_imagen_jugador_1')}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = Asset.get('eventodeportivo_placeholder_imagen_jugador_1');
          }}
        />
      </div>

      <div className='estadisticas-top4to10__data-block'>
        <p className='estadisticas-top4to10__player'>{player.player.name}</p>
        <p className='estadisticas-top4to10__score'>{Utils.cutPlayerString(player.player.value ? player.player.value : '0000', 4)}</p>
        <p className='estadisticas-top4to10__country'>{player.player.country.name}</p>
        <img
          className='estadisticas-top4to10__flag'
          src={player.player.country.flag ? player.player.country.flag : Asset.get('eventodeportivo_placeholder_imagen_bandera_1')}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = Asset.get('eventodeportivo_placeholder_imagen_bandera_1');
          }}
        />
      </div>
    </div>
  )
}

export default CardTop4to10



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/EstadisticasJuegos/Components/CardTop4to10/index.jsx